var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.138,
    height: 20.82,
    viewBox: "0 0 20.138 20.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_247",
    "data-name": "Group 247",
    transform: "translate(-37.448 -13.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_245",
    "data-name": "Group 245",
    transform: "translate(2.698 15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1376",
    "data-name": "Path 1376",
    d: "M12.9,0c.133,0,.259.005.381.011h.023a6.159,6.159,0,0,1,2.981.955,6.457,6.457,0,0,1,2.072,2.146A6.6,6.6,0,0,1,18.665,9.3l-4.94,10.5a.91.91,0,0,1-1.647,0L7.138,9.3a6.6,6.6,0,0,1,.306-6.189A6.457,6.457,0,0,1,9.516.967,6.159,6.159,0,0,1,12.5.012h.023C12.643.005,12.769,0,12.9,0Zm.345,1.105h-.011c-.115-.005-.224-.01-.333-.01s-.218,0-.333.01h-.011A5.151,5.151,0,0,0,8.385,3.672a5.5,5.5,0,0,0-.256,5.163L12.9,18.976,17.674,8.835a5.5,5.5,0,0,0-.256-5.163A5.151,5.151,0,0,0,13.246,1.105ZM12.9,2.738A3.286,3.286,0,1,1,9.616,6.024,3.289,3.289,0,0,1,12.9,2.738Zm0,5.476a2.19,2.19,0,1,0-2.19-2.19A2.193,2.193,0,0,0,12.9,8.214Z",
    transform: "translate(32.055 -1)",
    fill: "#157fee",
    stroke: "#157fee",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_30",
    "data-name": "Line 30",
    d: "M4.8.1H-.452A.548.548,0,0,1-1-.452.548.548,0,0,1-.452-1H4.8a.548.548,0,0,1,.548.548A.548.548,0,0,1,4.8.1Z",
    transform: "translate(36 16.429)",
    fill: "#157fee",
    stroke: "#157fee",
    strokeLinecap: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_31",
    "data-name": "Line 31",
    d: "M4.8.1H-.452A.548.548,0,0,1-1-.452.548.548,0,0,1-.452-1H4.8a.548.548,0,0,1,.548.548A.548.548,0,0,1,4.8.1Z",
    transform: "translate(49.295 16.429)",
    fill: "#157fee",
    stroke: "#157fee",
    strokeLinecap: "round",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/locationIcon.bb67ab2383ea4bf6c4cfb42a83f52700.svg";
export { ForwardRef as ReactComponent };